import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import { assets } from "../assets/assets";
import './conserto_relogio.css'; // Reutilizando o CSS para manter o padrão
import { abrirOrcamentoWhats, trazerRodapePaginasServicos, trazerTituloServicos } from '../utils/utils';

const GravacaoLaser = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Serviços de Gravação a laser";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />

      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.gravacaoLaser})` }}>
        <div className="servico-hero-overlay">
          <h1>Serviços de Gravação a Laser</h1>
          <p>Sua marca em cada detalhe.</p>
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloServicos('gravações a laser')}</h2>
        </article>

        {/* Bloco 1: Copos, Inox e Canetas */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Metais</h3>

            <h4>Gravação em inox</h4>
            <p>Marcação precisa em copos Stanley e similares, canecas, utensílios, placas e objetos metálicos.</p>

            <h4>Gravação em aço e alumínio</h4>
            <p>Personalização durável para brindes, placas e objetos de uso diário.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.gravacaoCopoCaneta} alt="Gravação a laser em copo e caneta" />
          </div>
        </section>

        {/* Bloco 2: Placas de Homenagem e Ouro */}
        <section className="sessao-explicativa reverse">
          <div className="texto-lado">
            <h3>Joias</h3>

            <h4>Gravação em ouro e prata</h4>
            <p>Marcação a laser em joias e peças de ouro e prata para identificação e personalização.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.gravacaoVersatil} alt="Gravação a laser em placa de homenagem e ouro" />
          </div>
        </section>

        {/* Bloco 3: Versatilidade e Outros Materiais (Genérico) */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Placas de homenagem</h3>

            <h4>Placas em metal</h4>
            <p>Gravação de textos, nomes e dedicatórias para reconhecimento e premiações.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.gravacaoPlacaOuro} alt="Gravação a laser em diversos materiais" />
          </div>
        </section>

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasServicos('serviços de gravações a laser')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('serviços em gravação a laser')}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default GravacaoLaser;